export default __webpack_public_path__ + "static/solution-api.url-3720a86737da1097298120cb77e74de5.svg";